import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
type Refresh = () => void

interface PostVentaStatusParams {
  refresh: Refresh
  notify: any
  hashItemReserve:string,
  setLoadingPostventaStatus: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setChangePostventaStatus: React.Dispatch<React.SetStateAction<boolean>>
  actualStatus:string
}

export const PostVentaStatus = async ({
  refresh,
  notify,
  hashItemReserve,
  setHashItemReserve,
  setLoadingPostventaStatus,
  setChangePostventaStatus,
  actualStatus
}: PostVentaStatusParams): Promise<void> => {
    let statusToChange = actualStatus === 'AFTER_SALES_HIDDEN' ? 'AFTER_SALES' : 'AFTER_SALES_HIDDEN'
    setLoadingPostventaStatus(true)
    await itemServices.update_status_item(statusToChange, hashItemReserve)
    .then(()=>{
      notify('ra.notification.updated_success_masculine', {
        type: 'success',
        messageArgs: { element: 'item' },
      })
    })
    .catch(()=>{
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: 'item' },
      })
    })
    .finally(async ()=>{
      customAwait([refresh])
      setLoadingPostventaStatus(false)
      setHashItemReserve('')
      setChangePostventaStatus(false)
    })

  }
